export const convertStudentsToCSV = (students) => {
  if (!students || students.length === 0) return "";

  // Define all headers based on the student model structure
  const headers = [
    "First Name",
    "Middle Name",
    "Last Name",
    "Date of Birth",
    "Blood Group",
    "Birth Place",
    "Caste Category",
    "Caste",
    "Aadhar Card Number",
    "Religion",
    "Student Mobile",
    "Email",
    "PRN Number",
    "ABC Number",
    "CAP Application ID",
    "Father Name",
    "Father Email",
    "Father Occupation",
    "Father Mobile",
    "Mother Name",
    "Mother Email",
    "Mother Occupation",
    "Mother Mobile",
    "Status",
    "Program",
    "Batch Name",
    "Register Number",
    "Roll Number",
    "Student ID",
  ];

  const csvRows = [headers.join(",")];

  students.forEach((student) => {
    const row = [
      `"${student?.studentDetails?.firstName || ""}"`,
      `"${student?.studentDetails?.middleName || ""}"`,
      `"${student?.studentDetails?.lastName || ""}"`,
      `"${student?.studentDetails?.dateOfBirth || ""}"`,
      `"${student?.studentDetails?.bloodGroup || ""}"`,
      `"${student?.studentDetails?.birthPlace || ""}"`,
      `"${student?.studentDetails?.casteCategory || ""}"`,
      `"${student?.studentDetails?.caste || ""}"`,
      `"${student?.studentDetails?.aadharCardNumber || ""}"`,
      `"${student?.studentDetails?.religion || ""}"`,
      `"${student?.studentDetails?.studentMobileNumber || ""}"`,
      `"${student?.studentDetails?.emailAddress || ""}"`,
      `"${student?.studentDetails?.prnNumber || ""}"`,
      `"${student?.studentDetails?.abcNumber || ""}"`,
      `"${student?.studentDetails?.capApplicationId || ""}"`,
      `"${student?.familyBackground?.fatherName || ""}"`,
      `"${student?.familyBackground?.fatherEmail || ""}"`,
      `"${student?.familyBackground?.fatherOccupation || ""}"`,
      `"${student?.familyBackground?.fatherMobileNo || ""}"`,
      `"${student?.familyBackground?.motherName || ""}"`,
      `"${student?.familyBackground?.motherEmail || ""}"`,
      `"${student?.familyBackground?.motherOccupation || ""}"`,
      `"${student?.familyBackground?.motherMobileNo || ""}"`,
      `"${student?.status || ""}"`,
      `"${student?.academicDetails?.program || ""}"`,
      `"${student?.academicDetails?.batch?.name || ""}"`,
      `"${student?.academicDetails?.registerNumber || ""}"`,
      `"${student?.academicDetails?.rollNumber || ""}"`,
      `"${student?.studentId || ""}"`,
    ].join(",");
    csvRows.push(row);
  });

  return csvRows.join("\n");
};

export const convertFacultiesToCSV = (faculties) => {
  if (!faculties || faculties.length === 0) return "";

  const headers = [
    "Faculty Name",
    "Department",
    "Email",
    "Phone",
    "Unique ID",
    "Date of Birth",
  ];

  const csvRows = [headers.join(",")];

  faculties.forEach((faculty) => {
    const row = [
      `"${faculty?.facultyName || ""}"`,
      `"${faculty?.department || ""}"`,
      `"${faculty?.email || ""}"`,
      `"${faculty?.phone || ""}"`,
      `"${faculty?.uniqueId || ""}"`,
      `"${
        faculty?.dateOfBirth
          ? new Date(faculty.dateOfBirth).toLocaleDateString()
          : ""
      }"`,
    ].join(",");
    csvRows.push(row);
  });

  return csvRows.join("\n");
};
